import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { RouteMap } from './components';

/* ---- Launcher (root page) ---- */
function Launcher() {
  return (
    <div className="launcher">
      <h1 className="launcher-title">TrendyEngine</h1>
      <p className="launcher-subtitle">What would you like to do?</p>
      <div className="launcher-cards">
        <a className="launcher-card" href="/games">
          <div className="launcher-card-icon">🎮</div>
          <h2 className="launcher-card-title">Games</h2>
          <p className="launcher-card-desc">Interactive HTML games — Question Builder, Word Reel, Candy Reel and more!</p>
          <span className="launcher-btn">PLAY</span>
        </a>
        <a className="launcher-card" href="/sailing">
          <div className="launcher-card-icon">⛵</div>
          <h2 className="launcher-card-title">Sailing</h2>
          <p className="launcher-card-desc">Navigate the open seas. Content coming soon!</p>
          <span className="launcher-btn">EXPLORE</span>
        </a>
      </div>
    </div>
  );
}

/* ---- Games redirect ---- */
function GamesRedirect() {
  window.location.href = '/games.html';
  return null;
}

/* ---- Sailing ---- */
function Sailing() {
  return (
    <div className="wf-page">
      <h1 className="launcher-title">⛵ Sailing</h1>
      <RouteMap />
      <a href="/" className="wf-back">
        <span className="wf-back-arrow">{'\u2190'}</span>
        <span>Back to home</span>
      </a>
    </div>
  );
}

/* ---- App ---- */
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Launcher />} />
          <Route path="/games" element={<GamesRedirect />} />
          <Route path="/sailing" element={<Sailing />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
